<!-- Footer -->
<p class="clearfix mb-0">
  <span class="float-md-left d-block d-md-inline-block mt-25">
    COPYRIGHT &copy; {{ year }}
    <a class="ml-25" [routerLink]="['']" target="_blank">XBaht</a>
    <span class="d-none d-sm-inline-block">, All rights Reserved</span>
  </span>
  <span class="float-md-right d-none d-md-block">
    Version {{ environment.version }} <span [data-feather]="'coffee'" [class]="'pink'"></span>
  </span>
</p>
<!--/ Footer -->

<!-- Move to top Button-->
@if (coreConfig.layout.scrollTop) {
  <xbaht-scroll-top></xbaht-scroll-top>
}
